import base32Encode from 'base32-encode'

const encoder = new TextEncoder()
const backendPrefix = '__BASE32__'

/**
 *
 */
export function stringToBase32(s: string) {
  const b32String = base32Encode(encoder.encode(s), 'RFC4648')
  return `${backendPrefix}${b32String}`
}
